import { plugin, debug } from 'light-component';
import { useEffect, useState, type ReactElement } from 'react';
import { Space, Select as ASelect } from 'antd';
import { t } from '../../i18n';
import { Require, Select } from '../component';
import styles from './style.module.less';
import type { StoreSelectProps, StoreOption } from './types';

export function WidgetMultiStore(props: StoreSelectProps): ReactElement {
  debug.widget('dashboard multiStore', props);
  let allOptions = props.options?.map?.(item => ({
    value: item.value,
    label: item.title as string,
    tags: item.tags,
    state: item.state,
    parent: item.parent
  })) ?? [];

  const uniqueValue = new Set(allOptions?.map(item => item.value));
  allOptions = allOptions?.filter(item => uniqueValue.delete(item.value));

  const tagOptions = props.tagOptions?.map?.(item => ({
    value: item.value,
    label: item.title as string
  })) ?? [];

  const [state, setState] = useState<string[]>([]);
  const [tags, setTags] = useState<string[]>([]);
  const [options, setOptions] = useState<StoreOption[]>([]);

  const handleChange = (value: string[]): void => {
    props.onChange?.(value?.length > 0 ? value : undefined);
  };

  const onStateChange = (value: string[]): void => {
    updateOption(tags, value);
    setState(value);
  };

  const onLabelsChange = (value: string[]): void => {
    updateOption(value, state);
    setTags(value);
  };

  const updateOption = (tags: string[], state: string[]): void => {
    let option = [...allOptions];
    if (tags.length > 0) {
      option = option.filter(option => tags.every(item => option.tags?.includes(item)));
    }
    if (state.length > 0) {
      option = option.filter(item => state.includes(item.state));
    }
    setOptions(option);
  };

  useEffect(() => {
    updateOption(tags, state);
  }, [props.options]);

  return (
    <div className={props.className ?? styles.propertyItem}>
      <div className={styles.input}>
        <Require require={props.require} />
        <span className={styles.title}>{t(props.title)}</span>
      </div>
      <Select
        className={styles.selectBox}
        mode='multiple'
        value={props.value}
        placeholder={t(props.placeholder ?? '')}
        options={options}
        allowClear
        selectAll={props.value?.length === options.length}
        onChange={handleChange}
        dropdownRender={(menu: React.ReactElement) => <>
          <Space direction='vertical' className={styles.storeFilter}>
            <Space>
              <span>
                {t('门店状态')}
              </span>
              <ASelect
                value={state}
                options={[
                  { label: t('正常营业'), value: 'normal' },
                  { label: t('营建中'), value: 'construct' },
                  { label: t('暂停营业'), value: 'suspended' },
                  { label: t('闭店'), value: 'defunct' }
                ]}
                onChange={onStateChange}
                mode='multiple'
                allowClear
                style={{ width: 250 }}
                onMouseDown={event => {
                  event.preventDefault();
                  event.stopPropagation();
                }}
              />
            </Space>
            <Space>
              <span>
                {t('门店标签')}
              </span>
              <ASelect
                value={tags}
                options={tagOptions}
                onChange={onLabelsChange}
                mode='multiple'
                allowClear
                style={{ width: 250 }}
                onMouseDown={event => {
                  event.preventDefault();
                  event.stopPropagation();
                }}
              />
            </Space>
          </Space>
          {menu}
        </>
        }
      />
    </div>
  );
}

plugin.register({ kind: 'widget', type: 'multiStore', component: WidgetMultiStore });
